(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barranauncio"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.velora-hc').forEach(function(raiz){
    return raiz;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenhas-1pag"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var diapositivas = raiz.querySelectorAll('[data-velora-resenas-diapositiva]');
    var textos = raiz.querySelectorAll('[data-velora-resenas-texto]');
    var puntos = raiz.querySelectorAll('[data-velora-resenas-punto]');
    if(diapositivas.length === 0) return;

    var indiceActual = 0;
    var intervalo = null;
    var duracion = parseFloat(raiz.getAttribute('data-velora-resenas-velocidad')) || 5;

    function mostrar(indice){
      indice = (indice + diapositivas.length) % diapositivas.length;
      diapositivas.forEach(function(el){ el.classList.remove('is-activa'); });
      textos.forEach(function(el){ el.classList.remove('is-activo'); });
      puntos.forEach(function(el){ el.classList.remove('is-activo'); });

      diapositivas[indice].classList.add('is-activa');
      if(textos[indice]) textos[indice].classList.add('is-activo');
      if(puntos[indice]) puntos[indice].classList.add('is-activo');

      indiceActual = indice;
    }

    function iniciarAutoplay(){
      detenerAutoplay();
      if(diapositivas.length <= 1) return;
      intervalo = setInterval(function(){
        mostrar(indiceActual + 1);
      }, duracion * 1000);
    }

    function detenerAutoplay(){
      if(intervalo){
        clearInterval(intervalo);
        intervalo = null;
      }
    }

    puntos.forEach(function(punto){
      punto.addEventListener('click', function(){
        var indice = parseInt(punto.getAttribute('data-indice'), 10) || 0;
        mostrar(indice);
        iniciarAutoplay();
      });
    });

    iniciarAutoplay();
  }

  document.querySelectorAll('.velora-resenas').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secciones-1pag"] && !Shopify.designMode) return;
  try {
    
(function(){
  var raiz = document.getElementById('velora-categorias-{{ section.id }}');
  if(!raiz) return;

  var pista = raiz.querySelector('[data-velora-categorias-pista]');
  var tarjetas = raiz.querySelectorAll('[data-velora-categorias-tarjeta]');
  var elementoActual = raiz.querySelector('[data-velora-categorias-actual]');
  var botonAnterior = raiz.querySelector('[data-velora-categorias-anterior]');
  var botonSiguiente = raiz.querySelector('[data-velora-categorias-siguiente]');

  if(!pista || tarjetas.length === 0) return;

  function indiceVisible(){
    var posicion = pista.scrollLeft;
    var indice = 0;
    var mejorDistancia = Infinity;
    tarjetas.forEach(function(tarjeta, i){
      var distancia = Math.abs(tarjeta.offsetLeft - pista.offsetLeft - posicion);
      if(distancia < mejorDistancia){
        mejorDistancia = distancia;
        indice = i;
      }
    });
    return indice;
  }

  function actualizarContador(){
    if(elementoActual){
      elementoActual.textContent = indiceVisible() + 1;
    }
  }

  function irATarjeta(indice){
    indice = Math.max(0, Math.min(tarjetas.length - 1, indice));
    var tarjeta = tarjetas[indice];
    if(tarjeta){
      pista.scrollTo({ left: tarjeta.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
    }
  }

  pista.addEventListener('scroll', function(){
    window.clearTimeout(pista._veloraScrollTimeout);
    pista._veloraScrollTimeout = window.setTimeout(actualizarContador, 100);
  });

  if(botonAnterior){
    botonAnterior.addEventListener('click', function(){
      irATarjeta(indiceVisible() - 1);
    });
  }

  if(botonSiguiente){
    botonSiguiente.addEventListener('click', function(){
      irATarjeta(indiceVisible() + 1);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-contador"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(numero){
    return String(numero).length < 2 ? '0' + numero : String(numero);
  }

  function inicializar(raiz){
    var horas = parseFloat(raiz.getAttribute('data-horas')) || 24;
    var reiniciar = raiz.getAttribute('data-reiniciar') === 'true';
    var clave = 'velora-contador-' + raiz.getAttribute('data-clave');
    var duracionMs = horas * 60 * 60 * 1000;

    var elHoras = raiz.querySelector('[data-velora-horas]');
    var elMinutos = raiz.querySelector('[data-velora-minutos]');
    var elSegundos = raiz.querySelector('[data-velora-segundos]');
    var cajas = raiz.querySelector('[data-velora-contador-cajas]');
    var finalizado = raiz.querySelector('[data-velora-contador-finalizado]');

    function obtenerFinDeCuenta(){
      var guardado = null;
      try{ guardado = window.localStorage.getItem(clave); }catch(error){ guardado = null; }
      var fin = guardado ? parseInt(guardado, 10) : null;
      if(!fin || isNaN(fin) || fin < Date.now()){
        fin = Date.now() + duracionMs;
        try{ window.localStorage.setItem(clave, String(fin)); }catch(error){}
      }
      return fin;
    }

    var finCuenta = obtenerFinDeCuenta();

    function actualizar(){
      var restante = finCuenta - Date.now();

      if(restante <= 0){
        if(reiniciar){
          finCuenta = Date.now() + duracionMs;
          try{ window.localStorage.setItem(clave, String(finCuenta)); }catch(error){}
          restante = duracionMs;
        } else {
          if(cajas) cajas.hidden = true;
          if(finalizado) finalizado.hidden = false;
          if(elHoras) elHoras.textContent = '00';
          if(elMinutos) elMinutos.textContent = '00';
          if(elSegundos) elSegundos.textContent = '00';
          return;
        }
      }

      var totalSegundos = Math.floor(restante / 1000);
      var h = Math.floor(totalSegundos / 3600);
      var m = Math.floor((totalSegundos % 3600) / 60);
      var s = totalSegundos % 60;

      if(elHoras) elHoras.textContent = pad(h);
      if(elMinutos) elMinutos.textContent = pad(m);
      if(elSegundos) elSegundos.textContent = pad(s);
    }

    actualizar();
    setInterval(actualizar, 1000);
  }

  document.querySelectorAll('[data-velora-contador]').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-cuenta"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(numero){
    return numero < 10 ? '0' + numero : String(numero);
  }

  function segundosHastaMedianoche(zona){
    var ahora = new Date();
    var h;
    var m;
    var s;

    if(zona && zona !== 'local'){
      try{
        var partes = new Intl.DateTimeFormat('en-GB', {
          timeZone: zona,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).formatToParts(ahora);
        partes.forEach(function(parte){
          if(parte.type === 'hour') h = parseInt(parte.value, 10) % 24;
          if(parte.type === 'minute') m = parseInt(parte.value, 10);
          if(parte.type === 'second') s = parseInt(parte.value, 10);
        });
      }catch(error){
        h = undefined;
      }
    }

    if(h === undefined || isNaN(h) || isNaN(m) || isNaN(s)){
      h = ahora.getHours();
      m = ahora.getMinutes();
      s = ahora.getSeconds();
    }

    return 86400 - (h * 3600 + m * 60 + s);
  }

  function inicializar(raiz){
    var zona = raiz.getAttribute('data-zona') || 'local';
    var elHoras = raiz.querySelector('[data-velora-cuenta-horas]');
    var elMinutos = raiz.querySelector('[data-velora-cuenta-minutos]');
    var elSegundos = raiz.querySelector('[data-velora-cuenta-segundos]');

    function actualizar(){
      var total = segundosHastaMedianoche(zona);
      if(total < 0) total = 0;
      var horas = Math.floor(total / 3600);
      var minutos = Math.floor((total % 3600) / 60);
      var segundos = total % 60;
      if(elHoras) elHoras.textContent = pad(horas);
      if(elMinutos) elMinutos.textContent = pad(minutos);
      if(elSegundos) elSegundos.textContent = pad(segundos);
    }

    actualizar();
    setInterval(actualizar, 1000);
  }

  document.querySelectorAll('[data-velora-cuenta]').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-destacados"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var itemsEscritorio = raiz.querySelectorAll('[data-velora-destacado-item]');
    var itemsMovil = raiz.querySelectorAll('[data-velora-destacado-item-movil]');
    var total = itemsEscritorio.length;
    if(total === 0) return;

    var duracion = parseFloat(raiz.getAttribute('data-velora-destacados-velocidad')) || 3;
    var indiceActual = 0;

    function mostrar(indice){
      indice = (indice + total) % total;
      itemsEscritorio.forEach(function(el){ el.classList.remove('is-activo'); });
      itemsMovil.forEach(function(el){ el.classList.remove('is-activo'); });
      if(itemsEscritorio[indice]) itemsEscritorio[indice].classList.add('is-activo');
      if(itemsMovil[indice]) itemsMovil[indice].classList.add('is-activo');
      indiceActual = indice;
    }

    if(total > 1){
      setInterval(function(){
        mostrar(indiceActual + 1);
      }, duracion * 1000);
    }
  }

  document.querySelectorAll('.velora-destacados').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-encabezado"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var botonAbrir = raiz.querySelector('[data-velora-enc-toggle]');
    var botonCerrar = raiz.querySelector('[data-velora-enc-cerrar]');
    var panel = raiz.querySelector('[data-velora-enc-menu-movil]');

    function abrirMenu(){
      panel.classList.add('is-abierto');
      botonAbrir.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function cerrarMenu(){
      panel.classList.remove('is-abierto');
      botonAbrir.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if(botonAbrir && panel){
      botonAbrir.addEventListener('click', function(){
        if(panel.classList.contains('is-abierto')){
          cerrarMenu();
        } else {
          abrirMenu();
        }
      });
    }

    if(botonCerrar){
      botonCerrar.addEventListener('click', cerrarMenu);
    }
  }

  document.querySelectorAll('.velora-enc').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var items = raiz.querySelectorAll('[data-velora-faq-item]');
    items.forEach(function(item){
      var boton = item.querySelector('[data-velora-faq-boton]');
      var panel = item.querySelector('[data-velora-faq-panel]');

      function actualizar(){
        if(item.classList.contains('is-abierto')){
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = '0px';
        }
      }

      actualizar();

      if(boton){
        boton.addEventListener('click', function(){
          item.classList.toggle('is-abierto');
          actualizar();
        });
      }
    });
  }

  document.querySelectorAll('.velora-faq').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-garantias"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var pista = raiz.querySelector('[data-velora-garantias-pista]');
    var items = raiz.querySelectorAll('[data-velora-garantia-item]');
    var botonAnterior = raiz.querySelector('[data-velora-garantias-anterior]');
    var botonSiguiente = raiz.querySelector('[data-velora-garantias-siguiente]');
    var relleno = raiz.querySelector('[data-velora-garantias-progreso]');

    if(!pista || items.length === 0) return;

    function indiceVisible(){
      var posicion = pista.scrollLeft;
      var indice = 0;
      var mejorDistancia = Infinity;
      items.forEach(function(item, i){
        var distancia = Math.abs(item.offsetLeft - pista.offsetLeft - posicion);
        if(distancia < mejorDistancia){
          mejorDistancia = distancia;
          indice = i;
        }
      });
      return indice;
    }

    function irAItem(indice){
      indice = Math.max(0, Math.min(items.length - 1, indice));
      var item = items[indice];
      if(item){
        pista.scrollTo({ left: item.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      }
    }

    function actualizarProgreso(){
      if(!relleno) return;
      var maximoScroll = pista.scrollWidth - pista.clientWidth;
      var progreso = maximoScroll > 0 ? pista.scrollLeft / maximoScroll : 0;
      var maximoTraslado = (items.length - 1) * 100;
      relleno.style.setProperty('--velora-garantias-progreso', (progreso * maximoTraslado) + '%');
    }

    pista.addEventListener('scroll', function(){
      window.clearTimeout(pista._veloraProgresoTimeout);
      pista._veloraProgresoTimeout = window.setTimeout(actualizarProgreso, 10);
    });

    actualizarProgreso();

    if(botonAnterior){
      botonAnterior.addEventListener('click', function(){
        irAItem(indiceVisible() - 1);
      });
    }

    if(botonSiguiente){
      botonSiguiente.addEventListener('click', function(){
        irAItem(indiceVisible() + 1);
      });
    }
  }

  document.querySelectorAll('.velora-garantias').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-historia"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.velora-historia').forEach(function(raiz){
    return raiz;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-manifiesto"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.velora-manifiesto').forEach(function(raiz){
    return raiz;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-producto"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializarGaleria(raiz){
    var imagenes = raiz.querySelectorAll('[data-velora-imagen-galeria]');
    var miniaturas = raiz.querySelectorAll('[data-velora-miniatura]');
    var prev = raiz.querySelector('[data-velora-galeria-prev]');
    var next = raiz.querySelector('[data-velora-galeria-next]');
    var indice = 0;

    function mostrar(nuevoIndice){
      if(imagenes.length === 0) return;
      indice = (nuevoIndice + imagenes.length) % imagenes.length;
      imagenes.forEach(function(img){ img.classList.remove('is-activa'); });
      miniaturas.forEach(function(min){ min.classList.remove('is-activa'); });
      if(imagenes[indice]) imagenes[indice].classList.add('is-activa');
      if(miniaturas[indice]) miniaturas[indice].classList.add('is-activa');
    }

    miniaturas.forEach(function(min){
      min.addEventListener('click', function(){
        mostrar(parseInt(min.getAttribute('data-indice'), 10));
      });
    });

    if(prev) prev.addEventListener('click', function(){ mostrar(indice - 1); });
    if(next) next.addEventListener('click', function(){ mostrar(indice + 1); });

    raiz.veloraMostrarImagen = mostrar;
  }

  function inicializarAcordeon(raiz){
    var items = raiz.querySelectorAll('[data-velora-acordeon-item]');
    items.forEach(function(item){
      var boton = item.querySelector('[data-velora-acordeon-boton]');
      var panel = item.querySelector('[data-velora-acordeon-panel]');
      function actualizar(){
        if(item.classList.contains('is-abierto')){
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = '0px';
        }
      }
      actualizar();
      if(boton){
        boton.addEventListener('click', function(){
          item.classList.toggle('is-abierto');
          actualizar();
        });
      }
    });
  }

  var NOMBRES_FECHA = {
    it: {
      dias: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
      meses: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic']
    },
    es: {
      dias: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      meses: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
    }
  };

  function obtenerFechaEnZona(zona){
    var ahora = new Date();
    var anio;
    var mes;
    var dia;

    if(zona && zona !== 'local'){
      try{
        var partes = new Intl.DateTimeFormat('en-US', {
          timeZone: zona,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        }).formatToParts(ahora);
        partes.forEach(function(parte){
          if(parte.type === 'year') anio = parseInt(parte.value, 10);
          if(parte.type === 'month') mes = parseInt(parte.value, 10);
          if(parte.type === 'day') dia = parseInt(parte.value, 10);
        });
      }catch(error){
        anio = undefined;
      }
    }

    if(anio === undefined || isNaN(anio) || isNaN(mes) || isNaN(dia)){
      anio = ahora.getFullYear();
      mes = ahora.getMonth() + 1;
      dia = ahora.getDate();
    }

    return new Date(Date.UTC(anio, mes - 1, dia));
  }

  function calcularFechaEnvio(hoy, dias, findeALunes, evitarFinde){
    var fecha = new Date(hoy.getTime());
    var diaSemana = fecha.getUTCDay();
    var sumar = dias;

    if(findeALunes && (diaSemana === 5 || diaSemana === 6 || diaSemana === 0)){
      sumar = diaSemana === 5 ? 3 : (diaSemana === 6 ? 2 : 1);
    }

    fecha.setUTCDate(fecha.getUTCDate() + sumar);

    if(evitarFinde){
      if(fecha.getUTCDay() === 6) fecha.setUTCDate(fecha.getUTCDate() + 2);
      if(fecha.getUTCDay() === 0) fecha.setUTCDate(fecha.getUTCDate() + 1);
    }

    return fecha;
  }

  function inicializarEnvio(raiz){
    var cajas = raiz.querySelectorAll('[data-velora-envio]');
    cajas.forEach(function(caja){
      var destino = caja.querySelector('[data-velora-envio-texto]');
      if(!destino) return;

      var zona = caja.getAttribute('data-zona') || 'local';
      var dias = parseInt(caja.getAttribute('data-dias'), 10);
      if(isNaN(dias)) dias = 2;
      var findeALunes = caja.getAttribute('data-finde-lunes') === 'true';
      var evitarFinde = caja.getAttribute('data-evitar-finde') === 'true';
      var idioma = caja.getAttribute('data-idioma') === 'es' ? 'es' : 'it';
      var plantilla = caja.getAttribute('data-texto') || '[fecha]';
      var nombres = NOMBRES_FECHA[idioma];

      function pintar(){
        var fecha = calcularFechaEnvio(obtenerFechaEnZona(zona), dias, findeALunes, evitarFinde);
        var textoFecha = nombres.dias[fecha.getUTCDay()] + ', ' + fecha.getUTCDate() + ' ' + nombres.meses[fecha.getUTCMonth()];
        var partes = plantilla.split('[fecha]');

        destino.innerHTML = '';
        destino.appendChild(document.createTextNode(partes[0]));
        var negrita = document.createElement('strong');
        negrita.textContent = textoFecha;
        destino.appendChild(negrita);
        if(partes.length > 1){
          destino.appendChild(document.createTextNode(partes.slice(1).join('[fecha]')));
        }
        caja.classList.add('is-listo');
      }

      pintar();
      setInterval(pintar, 60000);
    });
  }

  function inicializarPacks(raiz){
    var contenedor = raiz.querySelector('[data-velora-packs]');
    if(!contenedor) return;

    var scriptDatos = raiz.querySelector('[data-velora-producto-json]');
    var variantes = [];
    try{ variantes = JSON.parse(scriptDatos ? scriptDatos.textContent : '[]'); }catch(error){ variantes = []; }

    var packs = contenedor.querySelectorAll('[data-velora-pack]');
    var aviso = contenedor.querySelector('[data-velora-pack-aviso]');
    var botonComprar = raiz.querySelector('[data-velora-boton-comprar]');
    var fotoDefecto = contenedor.getAttribute('data-foto-defecto') || '';
    var packActivo = contenedor.querySelector('[data-velora-pack].is-abierto') || packs[0];

    function buscarVariante(valores){
      for(var i = 0; i < variantes.length; i++){
        var opciones = variantes[i].options;
        var coincide = true;
        for(var j = 0; j < valores.length; j++){
          if(valores[j] !== undefined && opciones[j] !== valores[j]){ coincide = false; break; }
        }
        if(coincide) return variantes[i];
      }
      return null;
    }

    function leerFila(fila){
      var valores = [];
      fila.querySelectorAll('[data-velora-pack-select]').forEach(function(selector){
        valores[parseInt(selector.getAttribute('data-posicion'), 10)] = selector.value;
      });
      return valores;
    }

    function urlFoto(variante){
      var origen = variante && variante.featured_image ? variante.featured_image.src : '';
      if(!origen) return fotoDefecto;
      return origen + (origen.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }

    function actualizarPack(pack){
      var filas = pack.querySelectorAll('[data-velora-pack-fila]');
      var descuento = parseFloat(pack.getAttribute('data-descuento')) || 0;
      var gratis = parseInt(pack.getAttribute('data-gratis'), 10) || 0;
      var total = 0;
      var precios = [];

      filas.forEach(function(fila){
        var variante = buscarVariante(leerFila(fila));
        var foto = fila.querySelector('[data-velora-pack-foto]');
        if(variante){
          total += variante.price;
          precios.push(variante.price);
        }
        if(foto) foto.style.backgroundImage = "url('" + urlFoto(variante) + "')";
      });

      var totalConDescuento = Math.round(total * (100 - descuento) / 100);
      if(gratis > 0){
        precios.sort(function(a, b){ return a - b; });
        var regalado = 0;
        for(var g = 0; g < gratis && g < precios.length; g++){ regalado += precios[g]; }
        totalConDescuento = total - regalado;
      }
      var precio = pack.querySelector('[data-velora-pack-precio]');
      var antes = pack.querySelector('[data-velora-pack-antes]');
      var ahorro = pack.querySelector('[data-velora-pack-ahorro]');
      var plantilla = pack.getAttribute('data-plantilla-ahorro') || '';

      if(precio) precio.textContent = formatearDinero(totalConDescuento);
      if(antes) antes.textContent = formatearDinero(total);
      if(ahorro) ahorro.textContent = plantilla.replace('[importe]', formatearDinero(total - totalConDescuento));
    }

    function itemsDelPack(pack){
      var cantidades = {};
      var orden = [];
      var validas = true;
      pack.querySelectorAll('[data-velora-pack-fila]').forEach(function(fila){
        var variante = buscarVariante(leerFila(fila));
        if(!variante || !variante.available){
          validas = false;
          return;
        }
        if(!cantidades[variante.id]){
          cantidades[variante.id] = 0;
          orden.push(variante.id);
        }
        cantidades[variante.id] += 1;
      });
      if(!validas) return null;
      return orden.map(function(id){ return { id: id, quantity: cantidades[id] }; });
    }

    function actualizarEstado(){
      var items = packActivo ? itemsDelPack(packActivo) : null;
      var valido = items !== null;
      if(aviso){
        if(valido){ aviso.classList.remove('is-visible'); } else { aviso.classList.add('is-visible'); }
      }
      if(botonComprar) botonComprar.disabled = !valido;
    }

    function seleccionar(pack){
      packs.forEach(function(otro){ otro.classList.remove('is-abierto'); });
      pack.classList.add('is-abierto');
      packActivo = pack;
      actualizarEstado();
    }

    packs.forEach(function(pack){
      var cabecera = pack.querySelector('[data-velora-pack-boton]');
      if(cabecera){
        cabecera.addEventListener('click', function(){ seleccionar(pack); });
      }
      pack.querySelectorAll('[data-velora-pack-select]').forEach(function(selector){
        selector.addEventListener('change', function(){
          actualizarPack(pack);
          actualizarEstado();
        });
      });
      actualizarPack(pack);
    });

    raiz.veloraItemsPack = function(){
      return packActivo ? itemsDelPack(packActivo) : null;
    };

    actualizarEstado();
  }

  function inicializarHalloween(raiz){
    var caja = raiz.querySelector('[data-velora-hw]');
    if(!caja) return;
    var cuenta = caja.querySelector('[data-velora-hw-cuenta]');
    var fin = new Date(caja.getAttribute('data-fin')).getTime();
    var etiquetas = (caja.getAttribute('data-etiquetas') || 'g|h|m|s').split('|');
    if(!cuenta || isNaN(fin)) return;

    function dos(numero){
      return numero < 10 ? '0' + numero : String(numero);
    }

    function bloque(valor, etiqueta){
      return '<span class="velora-producto__hw-bloque"><span class="velora-producto__hw-numero">' + valor + '</span><span class="velora-producto__hw-unidad">' + etiqueta + '</span></span>';
    }

    var temporizador = null;

    function actualizar(){
      var resto = Math.floor((fin - Date.now()) / 1000);
      if(resto <= 0){
        caja.classList.add('is-terminado');
        if(temporizador) clearInterval(temporizador);
        return;
      }
      var dias = Math.floor(resto / 86400);
      var horas = Math.floor((resto % 86400) / 3600);
      var minutos = Math.floor((resto % 3600) / 60);
      var segundos = resto % 60;
      cuenta.innerHTML = bloque(dias, etiquetas[0]) + bloque(dos(horas), etiquetas[1]) + bloque(dos(minutos), etiquetas[2]) + bloque(dos(segundos), etiquetas[3]);
    }

    actualizar();
    temporizador = setInterval(actualizar, 1000);
  }

  function recortar(texto){
    return texto.replace(/^\s+|\s+$/g, '');
  }

  function construirTablasTallas(raiz){
    var origenes = raiz.querySelectorAll('[data-velora-tabla-origen]');
    origenes.forEach(function(origen){
      var contenedor = origen.parentNode;
      var destino = contenedor ? contenedor.querySelector('[data-velora-tabla-destino]') : null;
      if(!destino) return;

      var lineas = origen.textContent.split(/\r?\n/);
      var tablas = [];
      var actual = null;

      lineas.forEach(function(linea){
        var limpia = recortar(linea);
        if(!limpia){
          actual = null;
          return;
        }
        var celdas = limpia.split(/\t|\s*\|\s*|\s{2,}/).map(recortar).filter(function(celda){
          return celda !== '';
        });
        if(celdas.length < 2) return;

        if(actual && actual.filas.length > 0 && celdas[0] === actual.cabecera[0]){
          actual = null;
        }
        if(!actual){
          actual = { cabecera: celdas, filas: [] };
          tablas.push(actual);
        } else {
          actual.filas.push(celdas);
        }
      });

      destino.innerHTML = '';
      tablas.forEach(function(datos){
        var tabla = document.createElement('table');
        tabla.className = 'velora-producto__tabla';

        var cabeza = document.createElement('thead');
        var filaCabeza = document.createElement('tr');
        datos.cabecera.forEach(function(texto){
          var th = document.createElement('th');
          th.textContent = texto;
          filaCabeza.appendChild(th);
        });
        cabeza.appendChild(filaCabeza);
        tabla.appendChild(cabeza);

        var cuerpo = document.createElement('tbody');
        datos.filas.forEach(function(fila){
          var tr = document.createElement('tr');
          fila.forEach(function(texto){
            var td = document.createElement('td');
            td.textContent = texto;
            tr.appendChild(td);
          });
          cuerpo.appendChild(tr);
        });
        tabla.appendChild(cuerpo);
        destino.appendChild(tabla);
      });
    });
  }

  function inicializarGuiaTallas(raiz){
    construirTablasTallas(raiz);
    var modal = raiz.querySelector('[data-velora-modal-guia]');
    var abrir = raiz.querySelector('[data-velora-abrir-guia]');
    var cerrarBotones = raiz.querySelectorAll('[data-velora-cerrar-guia]');
    var tabs = raiz.querySelectorAll('[data-velora-tab-unidad]');
    var paneles = raiz.querySelectorAll('[data-velora-unidad]');

    if(abrir && modal){
      abrir.addEventListener('click', function(){
        modal.classList.add('is-abierto');
      });
    }

    cerrarBotones.forEach(function(boton){
      boton.addEventListener('click', function(){
        if(modal) modal.classList.remove('is-abierto');
      });
    });

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var unidad = tab.getAttribute('data-velora-tab-unidad');
        tabs.forEach(function(t){ t.classList.remove('is-activo'); });
        tab.classList.add('is-activo');
        paneles.forEach(function(panel){
          if(panel.getAttribute('data-velora-unidad') === unidad){
            panel.hidden = false;
          } else {
            panel.hidden = true;
          }
        });
      });
    });
  }

  function actualizarContadorCarrito(cantidad){
    var contadores = document.querySelectorAll('.velora-encabezado__contador-carrito, .velora-hc__contador-carrito');
    contadores.forEach(function(el){
      el.textContent = cantidad;
      if(cantidad > 0){ el.classList.add('is-visible'); } else { el.classList.remove('is-visible'); }
    });
  }

  function formatearDinero(centavos){
    return '€' + (centavos / 100).toFixed(2).replace('.', ',');
  }

  function inicializarVariantes(raiz){
    var scriptDatos = raiz.querySelector('[data-velora-producto-json]');
    if(!scriptDatos) return;
    var variantes = [];
    try{ variantes = JSON.parse(scriptDatos.textContent); }catch(error){ variantes = []; }
    if(variantes.length === 0) return;

    var grupos = raiz.querySelectorAll('[data-velora-opcion]');
    var inputVariante = raiz.querySelector('[data-velora-input-variante]');
    var botonComprar = raiz.querySelector('[data-velora-boton-comprar]');
    var textoBoton = raiz.querySelector('[data-velora-boton-texto]');
    var precioActual = raiz.querySelector('[data-velora-precio-actual]');
    var precioAnterior = raiz.querySelector('[data-velora-precio-anterior]');
    var porcentajeDescuento = raiz.querySelector('[data-velora-porcentaje-descuento]');

    var seleccionActual = [];
    grupos.forEach(function(grupo){
      var posicion = parseInt(grupo.getAttribute('data-posicion-opcion'), 10);
      var seleccionado = grupo.querySelector('.is-seleccionado');
      seleccionActual[posicion] = seleccionado ? seleccionado.getAttribute('data-valor') : null;
    });

    function encontrarVariante(seleccion){
      for(var i = 0; i < variantes.length; i++){
        var opciones = variantes[i].options;
        var coincide = true;
        for(var j = 0; j < seleccion.length; j++){
          if(seleccion[j] && opciones[j] !== seleccion[j]){ coincide = false; break; }
        }
        if(coincide) return variantes[i];
      }
      return null;
    }

    function existeCombinacionDisponible(posicion, valor){
      var pruebaSeleccion = seleccionActual.slice();
      pruebaSeleccion[posicion] = valor;
      for(var i = 0; i < variantes.length; i++){
        var opciones = variantes[i].options;
        var coincide = true;
        for(var j = 0; j < pruebaSeleccion.length; j++){
          if(pruebaSeleccion[j] && opciones[j] !== pruebaSeleccion[j]){ coincide = false; break; }
        }
        if(coincide && variantes[i].available) return true;
      }
      return false;
    }

    function actualizarDisponibilidad(){
      grupos.forEach(function(grupo){
        var posicion = parseInt(grupo.getAttribute('data-posicion-opcion'), 10);
        var botones = grupo.querySelectorAll('[data-velora-valor-opcion]');
        botones.forEach(function(boton){
          var valor = boton.getAttribute('data-valor');
          if(existeCombinacionDisponible(posicion, valor)){
            boton.classList.remove('is-agotado');
          } else {
            boton.classList.add('is-agotado');
          }
        });
      });
    }

    function actualizarVista(){
      var variante = encontrarVariante(seleccionActual);
      if(!variante) return;

      if(inputVariante) inputVariante.value = variante.id;

      if(precioActual) precioActual.textContent = formatearDinero(variante.price);

      var tieneDescuento = variante.compare_at_price && variante.compare_at_price > variante.price;
      if(precioAnterior){
        if(tieneDescuento){
          precioAnterior.textContent = formatearDinero(variante.compare_at_price);
          precioAnterior.style.display = '';
        } else {
          precioAnterior.style.display = 'none';
        }
      }
      var porcentaje = tieneDescuento ? Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100) : 0;
      if(porcentajeDescuento){
        if(tieneDescuento){
          porcentajeDescuento.textContent = '-' + porcentaje + '%';
          porcentajeDescuento.style.display = '';
        } else {
          porcentajeDescuento.style.display = 'none';
        }
      }
      if(botonComprar){
        botonComprar.disabled = !variante.available;
        botonComprar.setAttribute('data-variant-id', variante.id);
      }
      if(textoBoton){
        textoBoton.textContent = variante.available ? textoBoton.getAttribute('data-velora-disponible') : textoBoton.getAttribute('data-velora-agotado');
      }

      if(variante.featured_image && raiz.veloraMostrarImagen){
        var imagenesGaleria = raiz.querySelectorAll('[data-velora-imagen-galeria]');
        for(var k = 0; k < imagenesGaleria.length; k++){
          var idImagen = parseInt(imagenesGaleria[k].getAttribute('data-image-id'), 10);
          if(idImagen === variante.featured_image.id){
            raiz.veloraMostrarImagen(k);
            break;
          }
        }
      }

      actualizarDisponibilidad();
    }

    grupos.forEach(function(grupo){
      var posicion = parseInt(grupo.getAttribute('data-posicion-opcion'), 10);
      var etiquetaSeleccion = grupo.querySelector('[data-velora-opcion-seleccion]');
      var botones = grupo.querySelectorAll('[data-velora-valor-opcion]');
      botones.forEach(function(boton){
        boton.addEventListener('click', function(){
          if(boton.classList.contains('is-agotado')) return;
          botones.forEach(function(b){ b.classList.remove('is-seleccionado'); });
          boton.classList.add('is-seleccionado');
          seleccionActual[posicion] = boton.getAttribute('data-valor');
          if(etiquetaSeleccion) etiquetaSeleccion.textContent = boton.getAttribute('data-valor');
          actualizarVista();
        });
      });
    });

    actualizarDisponibilidad();
  }

  function formatearMiles(numero){
    var texto = String(Math.round(numero));
    var resultado = '';
    for(var i = 0; i < texto.length; i++){
      var posicionDesdeElFinal = texto.length - i;
      resultado += texto[i];
      if(posicionDesdeElFinal > 1 && posicionDesdeElFinal % 3 === 1){
        resultado += '.';
      }
    }
    return resultado;
  }

  function inicializarContadorSocial(raiz){
    var elemento = raiz.querySelector('[data-velora-social-numero]');
    if(!elemento) return;
    var base = parseInt(elemento.getAttribute('data-numero-base'), 10) || 0;
    var intervaloSegundos = parseInt(elemento.getAttribute('data-intervalo'), 10) || 8;
    var actual = base;
    elemento.textContent = formatearMiles(actual);

    setInterval(function(){
      actual += Math.floor(Math.random() * 3) + 1;
      elemento.textContent = formatearMiles(actual);
    }, intervaloSegundos * 1000);
  }

  function obtenerElementoCarritoDestino(){
    var selectores = [
      '.velora-encabezado__icono-carrito',
      '.velora-hc__icono-carrito',
      '.velora-encabezado__contador-carrito',
      '.velora-hc__contador-carrito',
      '[data-velora-icono-carrito]',
      'a[href="/cart"]'
    ];
    for(var i = 0; i < selectores.length; i++){
      var el = document.querySelector(selectores[i]);
      if(el) return el;
    }
    return null;
  }

  function animarVueloCarrito(raiz){
    var imagenActiva = raiz.querySelector('.velora-producto__imagen.is-activa');
    if(!imagenActiva) return;

    var origen = imagenActiva.getBoundingClientRect();
    var destinoEl = obtenerElementoCarritoDestino();
    var destino = destinoEl ? destinoEl.getBoundingClientRect() : null;
    var destinoX = destino ? (destino.left + destino.width / 2) : (window.innerWidth - 36);
    var destinoY = destino ? (destino.top + destino.height / 2) : 28;

    var inicioX = origen.left + origen.width / 2;
    var inicioY = origen.top + origen.height / 2;
    var controlX = (inicioX + destinoX) / 2;
    var controlY = Math.min(inicioY, destinoY) - 160;

    var tamanoInicial = 70;
    var bola = document.createElement('div');
    bola.className = 'velora-producto__bola-vuelo';
    bola.style.backgroundImage = 'url(' + imagenActiva.src + ')';
    bola.style.width = tamanoInicial + 'px';
    bola.style.height = tamanoInicial + 'px';
    bola.style.left = (inicioX - tamanoInicial / 2) + 'px';
    bola.style.top = (inicioY - tamanoInicial / 2) + 'px';
    document.body.appendChild(bola);

    var duracion = 750;
    var inicioTiempo = null;

    function cuadro(tiempoActual){
      if(inicioTiempo === null) inicioTiempo = tiempoActual;
      var progreso = Math.min((tiempoActual - inicioTiempo) / duracion, 1);
      var inversa = 1 - progreso;
      var x = (inversa * inversa * inicioX) + (2 * inversa * progreso * controlX) + (progreso * progreso * destinoX);
      var y = (inversa * inversa * inicioY) + (2 * inversa * progreso * controlY) + (progreso * progreso * destinoY);
      var escala = 1 - (progreso * 0.65);
      var tamanoActual = tamanoInicial * escala;

      bola.style.width = tamanoActual + 'px';
      bola.style.height = tamanoActual + 'px';
      bola.style.left = (x - tamanoActual / 2) + 'px';
      bola.style.top = (y - tamanoActual / 2) + 'px';
      bola.style.opacity = String(1 - (progreso * 0.25));

      if(progreso < 1){
        window.requestAnimationFrame(cuadro);
      } else {
        bola.remove();
        var destinoFinalEl = obtenerElementoCarritoDestino();
        if(destinoFinalEl){
          destinoFinalEl.classList.add('is-rebote-carrito');
          setTimeout(function(){ destinoFinalEl.classList.remove('is-rebote-carrito'); }, 320);
        }
      }
    }
    window.requestAnimationFrame(cuadro);
  }

  function inicializarCarritoLateral(){
    if(window.veloraCarritoLateralListo) return;
    window.veloraCarritoLateralListo = true;

    var panel = document.querySelector('[data-velora-panel-carrito]');
    if(!panel) return;

    function render(carrito){
      var lista = document.querySelector('[data-velora-carrito-lista]');
      var pie = document.querySelector('[data-velora-carrito-pie]');
      var subtotalEl = document.querySelector('[data-velora-carrito-subtotal]');
      if(!lista) return;

      if(!carrito.items || carrito.items.length === 0){
        var vacioTexto = lista.getAttribute('data-velora-texto-vacio') || '';
        lista.innerHTML = '<p class="velora-producto__carrito-vacio" data-velora-carrito-vacio>' + vacioTexto + '</p>';
        if(pie) pie.hidden = true;
        return;
      }

      var itemsHtml = '';
      carrito.items.forEach(function(item){
        itemsHtml += '<div class="velora-producto__carrito-item">' +
          '<img src="' + item.image + '" alt="' + item.product_title + '">' +
          '<div class="velora-producto__carrito-item-info">' +
            '<p class="velora-producto__carrito-item-titulo">' + item.product_title + '</p>' +
            (item.variant_title ? '<p class="velora-producto__carrito-item-variante">' + item.variant_title + '</p>' : '') +
            '<p class="velora-producto__carrito-item-precio">' + formatearDinero(item.final_price) + ' × ' + item.quantity + '</p>' +
          '</div>' +
        '</div>';
      });
      lista.innerHTML = itemsHtml;
      if(pie) pie.hidden = false;
      if(subtotalEl) subtotalEl.textContent = formatearDinero(carrito.total_price);
    }

    function abrir(carrito){
      if(carrito) render(carrito);
      panel.classList.add('is-abierto');
      document.querySelectorAll('[data-velora-cerrar-carrito]').forEach(function(el){
        if(el.classList.contains('velora-producto__carrito-fondo')) el.classList.add('is-visible');
      });
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('velora-carrito-bloqueado');
    }

    function cerrar(){
      panel.classList.remove('is-abierto');
      document.querySelectorAll('[data-velora-cerrar-carrito]').forEach(function(el){
        if(el.classList.contains('velora-producto__carrito-fondo')) el.classList.remove('is-visible');
      });
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('velora-carrito-bloqueado');
    }

    document.querySelectorAll('[data-velora-cerrar-carrito]').forEach(function(el){
      el.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function(evento){
      if(evento.key === 'Escape') cerrar();
    });

    window.veloraAbrirCarrito = abrir;
    window.veloraCerrarCarrito = cerrar;

    document.addEventListener('velora:carrito-actualizado', function(evento){
      abrir(evento.detail);
    });
  }

  function inicializarBotonCarrito(raiz){
    var formulario = raiz.querySelector('[data-velora-formulario]');
    var boton = raiz.querySelector('[data-velora-boton-comprar]');
    var textoBotonCarrito = raiz.querySelector('[data-velora-boton-texto]');
    if(!formulario || !boton) return;

    formulario.addEventListener('submit', function(evento){
      evento.preventDefault();
      if(boton.disabled || boton.classList.contains('is-cargando')) return;
      var input = raiz.querySelector('[data-velora-input-variante]');
      if(!input) return;

      var itemsPack = raiz.veloraItemsPack ? raiz.veloraItemsPack() : undefined;
      if(itemsPack === null) return;
      var cuerpoPeticion = itemsPack ? { items: itemsPack } : { id: input.value, quantity: 1 };

      boton.classList.add('is-cargando');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cuerpoPeticion)
      })
        .then(function(respuesta){
          return respuesta.json().then(function(datos){
            return { fue_exitosa: respuesta.ok, datos: datos };
          });
        })
        .then(function(resultado){
          boton.classList.remove('is-cargando');
          if(resultado.fue_exitosa){
            boton.classList.add('is-agregado');
            if(textoBotonCarrito){
              textoBotonCarrito.textContent = textoBotonCarrito.getAttribute('data-velora-agregado') || textoBotonCarrito.textContent;
            }
            if(raiz.getAttribute('data-velora-animacion') === 'true'){
              animarVueloCarrito(raiz);
            }
            fetch('/cart.js').then(function(r){ return r.json(); }).then(function(carrito){
              actualizarContadorCarrito(carrito.item_count);
              if(raiz.getAttribute('data-velora-carrito-lateral') === 'true' && window.veloraAbrirCarrito){
                window.veloraAbrirCarrito(carrito);
              }
            });
            setTimeout(function(){
              boton.classList.remove('is-agregado');
              if(textoBotonCarrito){
                textoBotonCarrito.textContent = textoBotonCarrito.getAttribute('data-velora-disponible') || textoBotonCarrito.textContent;
              }
            }, 1800);
          } else {
            boton.classList.add('is-error');
            setTimeout(function(){ boton.classList.remove('is-error'); }, 2200);
          }
        })
        .catch(function(){
          boton.classList.remove('is-cargando');
          boton.classList.add('is-error');
          setTimeout(function(){ boton.classList.remove('is-error'); }, 2200);
        });
    });
  }

  document.querySelectorAll('.velora-producto').forEach(function(raiz){
    inicializarGaleria(raiz);
    inicializarAcordeon(raiz);
    inicializarGuiaTallas(raiz);
    inicializarEnvio(raiz);
    inicializarVariantes(raiz);
    inicializarPacks(raiz);
    inicializarHalloween(raiz);
    inicializarBotonCarrito(raiz);
    inicializarContadorSocial(raiz);
    inicializarCarritoLateral();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-testimonios"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var pista = raiz.querySelector('[data-velora-testimonios-pista]');
    var tarjetas = raiz.querySelectorAll('[data-velora-testimonio-tarjeta]');
    var botonAnterior = raiz.querySelector('[data-velora-testimonios-anterior]');
    var botonSiguiente = raiz.querySelector('[data-velora-testimonios-siguiente]');

    if(!pista || tarjetas.length === 0) return;

    function indiceVisible(){
      var posicion = pista.scrollLeft;
      var indice = 0;
      var mejorDistancia = Infinity;
      tarjetas.forEach(function(tarjeta, i){
        var distancia = Math.abs(tarjeta.offsetLeft - pista.offsetLeft - posicion);
        if(distancia < mejorDistancia){
          mejorDistancia = distancia;
          indice = i;
        }
      });
      return indice;
    }

    function irATarjeta(indice){
      indice = Math.max(0, Math.min(tarjetas.length - 1, indice));
      var tarjeta = tarjetas[indice];
      if(tarjeta){
        pista.scrollTo({ left: tarjeta.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      }
    }

    if(botonAnterior){
      botonAnterior.addEventListener('click', function(){
        irATarjeta(indiceVisible() - 1);
      });
    }

    if(botonSiguiente){
      botonSiguiente.addEventListener('click', function(){
        irATarjeta(indiceVisible() + 1);
      });
    }
  }

  document.querySelectorAll('.velora-testimonios').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-vendidos"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.velora-vendidos').forEach(function(raiz){
    var tarjetas = raiz.querySelectorAll('[data-velora-tarjeta]');
    tarjetas.forEach(function(tarjeta){
      tarjeta.addEventListener('pointerenter', function(){
        tarjeta.classList.add('is-hover');
      });
      tarjeta.addEventListener('pointerleave', function(){
        tarjeta.classList.remove('is-hover');
      });
      tarjeta.addEventListener('touchstart', function(){
        tarjeta.classList.add('is-hover');
      }, { passive: true });
      tarjeta.addEventListener('touchend', function(){
        tarjeta.classList.remove('is-hover');
      });
      tarjeta.addEventListener('touchcancel', function(){
        tarjeta.classList.remove('is-hover');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-ventajas"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializar(raiz){
    var pista = raiz.querySelector('[data-velora-ventajas-pista]');
    var items = raiz.querySelectorAll('[data-velora-ventaja-item]');
    var relleno = raiz.querySelector('[data-velora-ventajas-progreso]');

    if(!pista || items.length === 0 || !relleno) return;

    relleno.style.setProperty('--velora-ventajas-total-items', items.length);

    function actualizarProgreso(){
      var maximoScroll = pista.scrollWidth - pista.clientWidth;
      var progreso = maximoScroll > 0 ? pista.scrollLeft / maximoScroll : 0;
      var maximoTraslado = (items.length - 1) * 100;
      relleno.style.setProperty('--velora-ventajas-progreso', (progreso * maximoTraslado) + '%');
    }

    pista.addEventListener('scroll', function(){
      window.clearTimeout(pista._veloraVentajasTimeout);
      pista._veloraVentajasTimeout = window.setTimeout(actualizarProgreso, 10);
    });

    actualizarProgreso();
  }

  document.querySelectorAll('.velora-ventajas').forEach(inicializar);
})();

  } catch(e) { console.error(e); }
})();
})();
